import { REQUEST_ITDOS_A} from '../../../const';

export default function ITDOSAReducer(state = [], action) {
  switch (action.type) {
      case REQUEST_ITDOS_A:
      return action.itdos_a;
    default:
      return state;
  }
}